import * as Sentry from "@sentry/browser";

if (
  window.env.environment !== "test" &&
  window.env.environment !== "development"
) {
  Sentry.init({
    dsn: window.env.sentryDsn,
    environment: window.env.environment ?? "production",
  });
}
